import { Icon } from "dash-ui";
import { useTranslation } from "react-i18next";
import { SubscriptionChangeMode } from "../SubscriptionChangeConfirmationModalV2.interfaces";
import { MODAL_STYLES } from "../SubscriptionChangeConfirmationModalV2.helpers";

interface ModalHeaderProps {
  mode: SubscriptionChangeMode;
  isTrial?: boolean;
  onClose: () => void;
}

export default function ModalHeader({
  mode,
  isTrial,
  onClose,
}: ModalHeaderProps) {
  const { t } = useTranslation("pages", {
    keyPrefix: "profilePage.billing.trialUpgrade",
  });
  const { t: tc } = useTranslation(["pages", "common"]);
  const headerStyles = MODAL_STYLES.header[mode];
  const title = isTrial
    ? t("title")
    : mode === "upgrade"
    ? tc("pages:profilePage.billing.changeConfirm.titleUpgrade")
    : tc("pages:profilePage.billing.changeConfirm.titleDowngrade");

  return (
    <div
      className={`-mx-6 -mt-11 px-6 pt-7 rounded-t-lg relative ${
        isTrial ? "mb-4 pb-4" : "mb-6 pb-7"
      }`}
      style={{ background: headerStyles.background }}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-1.5 bg-white hover:bg-gray-100 transition-colors  rounded"
        aria-label={tc("common:labels.close") || ""}
      >
        <Icon name="close" size={16} color="#6B7280" />
      </button>
      <h2
        className="text-xl font-bold text-slate-800 pr-8"
        style={{ color: headerStyles.color }}
      >
        {title}
      </h2>
      {!isTrial && (
        <p
          className="text-sm text-slate-500 mt-1"
          style={{ color: headerStyles.color }}
        >
          {mode === "upgrade"
            ? tc("pages:profilePage.billing.changeConfirm.reviewUpgrade")
            : tc("pages:profilePage.billing.changeConfirm.reviewDowngrade")}
        </p>
      )}
    </div>
  );
}
